import {Component, Input} from "@angular/core";

/**
 * A component that renders an SVG icon for "Camera Lock Open"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-camera-lock-open',
    templateUrl: './icon-camera-lock-open.component.html',
    styleUrls: ['./icon-camera-lock-open.component.scss'],
    standalone: false
})
export class IconCameraLockOpenComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
